import React, { useEffect, useState } from "react";
import ContentAuthor from "../ContentAuthor";
import { getDateFormatForHead, datePost } from "@/helpers/formatDate";
import RelatedLilaNews from "@/shared/RelatedLilaNews";
import { NewsRead } from "@/shared/NewsRead";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import { ReviewStars } from "@/shared/ToolBarRecipes/ReviewStars";

const ContentTitle = (props) => {
  const {
    _id,
    title,
    summary,
    subtitle,
    section,
    author,
    iconMultimedia,
    type,
    authorSignature,
    titleLocation = "",
    payWallExclusive,
    relatedLilaNews = [],
    cutTitle,
    showDate,
    dateHours = false,
    date,
    contentType,
    showSectionOrAuthorName = true,
    showSectionWithTitle,
    alwaysShowSectionName = false
  } = props;

  const dataContext = useContext(TemplateContext);
  const { content } = dataContext;
  const { recipesReview } = content;

  const summaryWithoutHtml = summary
    ? summary.replace(/(<([^>]+)>)/gi, "")
    : "";
  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    if (date && showDate) {
      const formattedDateValue = dateHours ? date : datePost(date);
      setFormattedDate(formattedDateValue);
    }
  }, [date, showDate, dateHours]);

  const authorName =
    Array.isArray(author) &&
      author.length &&
      typeof author[0].name !== "undefined"
      ? author[0].name
      : "";

  const sectionWithUnderscore = "_7_";
  const noteIdWithSection = sectionWithUnderscore + _id;
  const dataReview = recipesReview?.find((review) => review.externalSubjectId == noteIdWithSection);

  const sectionName = (Array.isArray(section) && section.length && typeof section[0].name !== 'undefined')
    ? section[0].name
    : "";
  const summaryValue = showSectionWithTitle ? sectionName : (summaryWithoutHtml && relatedLilaNews && summaryWithoutHtml);

  // console.log('propsp',props)
  return (
    <div type={type} className={` mt ${titleLocation}`}>
      <h2 suppressHydrationWarning type={type} className={`title ${cutTitle ? "shortenTitle" : ""}`}>
        {title
          ?.replace('"', "“")
          .replace('"', "”")
          .replace('"', "“")
          .replace('"', "”")}
      </h2>
      <p>
      </p>
      {summaryWithoutHtml && relatedLilaNews &&
        <div className="bottomSummary">
          {summaryWithoutHtml && <p className="bajada">{summaryValue}</p>}
          <RelatedLilaNews content={relatedLilaNews} />
        </div>
      }

      <div>
        {showDate && (
          <span className="date" aria-hidden="true">{formattedDate && formattedDate}</span>
        )}
        {contentType == "recipe" &&
          <ReviewStars dataReview={dataReview} />
        }
      </div>

      {subtitle && (
        <div className={`volanta ${iconMultimedia ? `has-icon-${iconMultimedia}` : ''}`}>
          {subtitle?.replace('"', "“").replace('"', "”")}
        </div>
      )}
      <ContentAuthor
        author={author}
        payWallExclusive={payWallExclusive}
        authorSignature={authorSignature}
        section={section}
        showSectionOrAuthorName={showSectionOrAuthorName}
        alwaysShowSectionName={alwaysShowSectionName}
      />
    </div>
  );
};

export default ContentTitle;
